module.exports = {

    props: {
        project: {
            type: Object,
            required: true,
        },
        employer: {
            type: Object,
            required: true,
        },
        technician: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            selectedAuthorUser: null,
            author: this.project.author,
            form: new Form(this.emptyData()).dontClear()
        }
    },

    created() {
        if(this.project.author) {
            if (this.project.author.email == this.project.employer.email) {
                this.selectedAuthorUser = 'employer'
            } else if (this.project.author.email == this.project.responsible.email) {
                this.selectedAuthorUser = 'technician'
            } else {
                this.selectedAuthorUser = 'other'
            }
        }
    },

    methods: {

        updateForm() {
            var data = this.isOther ? this.emptyData() : this.userAsAuthor();
            this.form = new Form(data).dontClear()
        },

        userAsAuthor() {
            return {
                name: this[this.selectedAuthorUser].name,
                email: this[this.selectedAuthorUser].email,
                phone: this[this.selectedAuthorUser].profile.phone,
                company: this[this.selectedAuthorUser].profile.company,
                address: this[this.selectedAuthorUser].profile.address,
                city: this[this.selectedAuthorUser].profile.city,
                state: this[this.selectedAuthorUser].profile.county.state.short_name,
                zip: this[this.selectedAuthorUser].profile.zip,
                id: this.project.author ? this.project.author.id : null,
            }
        },

        emptyData() {
            if (this.project.author) return this.project.author;
            return {
                name: '',
                email: '',
                phone: '',
                company: '',
                address: '',
                city: '',
                state: '',
                zip: '',
            }
        },

        save() {
            this.form.post(`/projects/${this.project.slug}/author`).then(response => {
                Toast.success("Author Information saved!")
                this.redirectTo(`/projects/${this.project.slug}/acceptance-documents`)
            }).catch(errors => {
                Alert.error(errors.first())
            })
        },

        resendAccess(){
            App.request().patch(`/projects/${this.project.slug}/author/${this.project.author.id}/resend-access`).then(response => {
                Toast.success("The Email is on the way!")
                this.author.mailed_access_url_at = moment().format()
                this.author.secure_url_expiration_date = moment().add(5, 'days').format()
            }).catch(errors => {
                Alert.error(errors.first())
            })
        }
    },

    computed: {
        isOther() {
            return this.selectedAuthorUser == 'other';
        },

        emailedSecureUrl(){
            return this.author && this.author.mailed_access_url_at != null;
        },

        secureUrlIsExpired(){
            if(this.author.mailed_access_url_at){
                return moment().isAfter(this.author.secure_url_expiration_date);
            }
            return false;
        }
    }
}
